module.exports = "/pages/business/foodslabo/service_icon_1.png";